import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/gender/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/gender/${query}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/gender/${id}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/gender`, data);
    } else {
      return API.apiClient.put(`/gender/${id}`, data);
    }
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/gender/search${query}`);
  }
};
